import { combineReducers } from "@reduxjs/toolkit";
import users from "./users";

export default combineReducers({
    users
});